namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeRecptSumItemQtyFg {
        ReceiptPrinterType0 = 0,
        ReceiptPrinterType1 = 1
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeRecptSumItemQtyFg, 'GeniuzPOS.Administration.PsParaGenTypeRecptSumItemQtyFg', 'Administration.PsParaGenTypeRecptSumItemQtyFg');
}
